import styled from 'styled-components';
import { Tabs, Tab } from '@blueprintjs/core';
import * as ReportModel from '../../../models/report';

const StyledTabs = styled(Tabs)`
  overflow-x: auto;
  width: 100%;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
  &::-webkit-scrollbar {
    display: none; /* Chrome/Safari/Opera */
  }

  .bp3-tab {
    color: #666;
    font-size: 1rem;
    font-family: var(--fonts-heading);

    &[aria-selected="true"] {
      font-weight: bold;
    }
  }
`;

const ReportTabs = ({ allReports = [], history }) => {
  const getBasePath = () => {
    const pathname = (history && history.location && history.location.pathname) || window.location.pathname || '';
    const first = pathname.split('/').filter(Boolean)[0];
    return first === 'my-reports' ? '/my-reports' : '/reports';
  };

  const handleTabClick = tab => {
    const path = `${getBasePath()}/${tab}`;
    if (!history) window.location.pathname = path;
    history.push(path);
  };

  const getSelectedTabId = () => {
    if (!history) return null;
    const { location = {} } = history;
    const { pathname = '' } = location;
    return pathname.split('/').pop();
  };

  const selectedTabId = getSelectedTabId();

  return (
    <StyledTabs
      id="SettingsTab"
      selectedTabId={selectedTabId}
      onChange={handleTabClick}
    >
      {allReports.map(({ name, id }) => (
        <Tab id={id} key={id} title={name} />
      ))}
    </StyledTabs>
  );
};

export default ReportTabs;
